module.exports = __webpack_public_path__ + "img/5.c453a8ee.jpg";